import { type PropsWithChildren } from 'react'
import { Fab as MuiFab, type FabProps as MuiFabProps } from '@mui/material'
import { type BaseProps } from '../../types'

export type FabProps = PropsWithChildren<Pick<MuiFabProps, 'size' | 'onClick' | 'href'>> & {
  /**
   * When you need more then the Icon only choose `extended`
   * @default circular
   */
  variant?: 'extended' | 'circular'

  disabled?: boolean

  'aria-label': string
} & BaseProps<
    HTMLDivElement,
    never,
    // TODO: maybe better to ask for positions, so for example
    // 'bottom-menu' (above the bottom menu)
    // 'bottom' (allways bottom, like where we do not have bottom-menu)
    {
      position?: 'fixed'
      top?: number | string
      bottom?: number | string
      right?: number | string
      left?: number | string
    }
  >

/**
 * Internal primitive using MUI its setup, not meant for external exposure
 * We have the construct Fabulous for this :)
 */
export const Fab = ({ children, variant = 'circular', ...props }: FabProps) => (
  <MuiFab color="primary" variant={variant} {...props}>
    {children}
  </MuiFab>
)
